import { Schema } from "mongoose"
import { z } from "zod"

import type { AclPolicy } from "../acl"


const ZStringMap = z.record(z.string(), z.string())

export const ZRBNotificationPlatformPayload = z.object({
  webpush: z.record(z.string(), z.unknown()).optional(),
  fcmOptions: z.record(z.string(), z.unknown()).optional(),
  android: z.record(z.string(), z.unknown()).optional(),
  apns: z.record(z.string(), z.unknown()).optional(),
}).passthrough()

export type IRBNotificationPlatformPayload = z.infer<typeof ZRBNotificationPlatformPayload>

export const ZRBNotification = z.object({
  userId: z.string(),
  topic: z.string().optional(),
  title: z.string(),
  body: z.string().optional(),
  image: z.string().optional(),
  data: ZStringMap.optional(),
  platform: ZRBNotificationPlatformPayload.optional(),
  createdAt: z.date(),
  seenAt: z.date().optional(),
  readAt: z.date().optional(),
  archivedAt: z.date().optional(),
})

export type IRBNotification = z.infer<typeof ZRBNotification>

const TTL_90_DAYS_S = 60 * 60 * 24 * 90

export const RBNotificationSchema: Schema = new Schema(
  {
    userId: { type: String, required: true, index: true },
    topic: { type: String, required: false, index: true },
    title: { type: String, required: true },
    body: { type: String, required: false },
    image: { type: String, required: false },
    data: { type: Schema.Types.Mixed, required: false },
    platform: { type: Schema.Types.Mixed, required: false },
    createdAt: { type: Date, required: true, default: Date.now, index: true },
    seenAt: { type: Date, required: false, index: true },
    readAt: { type: Date, required: false, index: true },
    archivedAt: { type: Date, required: false },
  },
  {
    versionKey: false,
  },
)

RBNotificationSchema.index({ userId: 1, archivedAt: 1, createdAt: -1 })
RBNotificationSchema.index({ userId: 1, seenAt: 1, archivedAt: 1, createdAt: -1 })
RBNotificationSchema.index({ userId: 1, readAt: 1, archivedAt: 1, createdAt: -1 })
RBNotificationSchema.index({ archivedAt: 1 }, { expireAfterSeconds: TTL_90_DAYS_S })

export const RBNotificationPolicy: AclPolicy = {
  subject: "RBNotification",
  define: (builder, ctx) => {
    if (!ctx.userId) return
    builder.can("create", "RBNotification")
    builder.can("read", "RBNotification", { userId: ctx.userId })
    builder.can("update", "RBNotification", { userId: ctx.userId })
    builder.can("delete", "RBNotification", { userId: ctx.userId })
  },
}
